import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import { EMAIL_AND_ID_IDENTIFIER_CONFIG, IdentifierType } from 'cio/utils/identifiers';
import Transition from '@ember/routing/-private/transition';
import { redirectIfAtWorkspaceLimit, redirectIfNoPermission } from 'cio/utils/route-access';
import DS from 'ember-data';
import AuthService from 'cio/services/auth';
import isDestroyed from 'cio/utils/is-destroyed';
import AccountService from 'cio/services/account';

export default class WorkspacesNewRoute extends Route {
  @service features!: FeaturesService;
  @service store!: DS.Store;
  @service auth!: AuthService;
  @service account!: AccountService;

  crumb() {
    return {
      name: 'Add Workspace',
      path: this.routeName,
    };
  }

  queryParams = {
    identifier: {
      refreshModel: false,
    },
  };

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    if (this.auth.hasPermission('account/view')) {
      return redirectIfAtWorkspaceLimit(this, transition);
    }
    return redirectIfNoPermission(this, 'account/workspaces/create', transition);
  }

  model() {
    let account = this.account.current;

    return this.store.query('user', {}).then((users) => {
      return {
        environment: this.store.createRecord('environment', {
          account,
          users,
          identifierType: IdentifierType.MultiIdentifier,
          identifiers: EMAIL_AND_ID_IDENTIFIER_CONFIG,
        }),
        users,
      };
    });
  }

  deactivate() {
    let { environment } = this.controller.model as Record<string, any>;

    // only unload the record if not persisted yet (i.e. not saved):
    if (!isDestroyed(this) && environment.get('isNew') === true) {
      environment.unloadRecord();
    }

    super.deactivate();
  }
}
